export const TRANSLATE_LABELS_DICTIONARY = {
  'class_manager.class_list.add_class':
    'online_event.group_manager.group_list.add_group',
  'class_manager.class_list.search_placeholder':
    'online_event.group_manager.group_list.search_placeholder',
  'class_manager.class_list.search_empty_state.title':
    'online_event.group_manager.group_list.search_empty_state.title',
  'class_manager.class_list.search_empty_state.description':
    'online_event.group_manager.group_list.search_empty_state.description',
  'class_manager.class_editor.create_class':
    'online_event.group_manager.group_editor.title',
  'class_manager.class_editor.edit_class':
    'online_event.group_manager.group_editor.title',
  'class_manager.class_editor.create_new_class':
    'online_event.group_manager.group_editor.create_new_group',
  'class_manager.class_editor.create_new_class_description':
    'online_event.group_manager.group_editor.create_new_group_description',
  'class_manager.class_editor.class_name':
    'online_event.group_manager.group_editor.group_name',
  'class_manager.class_editor.offers_tooltip':
    'online_event.group_manager.group_editor.offers_tooltip',
  'class_manager.class_editor.offers_description':
    'online_event.group_manager.group_editor.offers_description',
  'class_manager.class_editor.default_class_tooltip':
    'online_event.group_manager.group_editor.default_group_tooltip',
  'class_manager.class_editor.manage_your_class':
    'online_event.group_manager.group_editor.manage_your_group',
  'class_manager.class_editor.manage_your_class_description':
    'online_event.group_manager.group_editor.manage_your_group_description',
  'content_list.add_module': 'online_event.content_list.add_module',
  'content_list.title': 'online_event.content_list.title',
  'content_list.which_classes': 'online_event.content_list.which_groups',
  'dripping.date.description': 'online_event.dripping.date.description',
  'dripping.days.description': 'online_event.dripping.days.description',
  'general.class': 'online_event.general.group',
  'general.class_tooltip': 'online_event.general.group_tooltip',
  'general.classes': 'online_event.general.groups',
  'general.content': 'online_event.general.content',
  'general.default_class': 'online_event.general.default_group',
  'general.default_class_label': 'online_event.general.default_group_label',
  'general.free_module': 'online_event.general.free_module',
  'general.student': 'online_event.general.student',
  'general.student_plural': 'online_event.general.student_plural',
  'general.student_empty': 'online_event.general.student_empty',
  'general.user': 'online_event.general.user',
  'general.users': 'online_event.general.users',
  'onboarding.start_adding_modules':
    'online_event.onboarding.start_adding_modules',
  'general.free_student': 'online_event.general.free_student',
  'files.insert_from_club': 'online_event.files.new_insert_from_club',
  'files.insert_from_computer': 'online_event.files.new_insert_from_computer',
  'module_editor.free_signup.description':
    'online_event.module_editor.free_signup.new_description',
  'module_editor.free_signup.toggle':
    'online_event.module_editor.free_signup.toggle',
  'module_editor.free_signup.info':
    'online_event.module_editor.free_signup.new_info',
  'module_editor.free_signup.info_link':
    'online_event.module_editor.free_signup.new_info_link',
  'module_editor.free_signup.info_sales_page':
    'online_event.module_editor.free_signup.new_info_sales_page',
  'module_editor.module_name': 'page_content.name_placeholder',
  'module_editor.title': 'online_event.module_editor.new_title',
  'module_editor.which_classes': 'online_event.module_editor.new_which_groups',
  'module_editor.which_classes_v2':
    'online_event.module_editor.new_which_groups',
  'module_editor.manage_classes': 'online_event.module_editor.manage_classes',
  'module_editor.manage_classes_tooltip':
    'online_event.module_editor.manage_classes_tooltip',
  'users_manager.users_list.empty':
    'online_event.users_manager.users_list.empty',
  'users_manager.users_list.header.users_import':
    'online_event.users_manager.users_list.header.users_import',
  'webinar_editor.form.transmission_provider.description':
    'online_event.webinar_editor.form.transmission_provider.description',
  'webinar_editor.form.after_exhibition.title':
    'online_event.webinar_editor.form.after_exhibition.title',
  'users_manager.big_numbers.user_average':
    'online_event.big_numbers.user_average',
  'users_manager.big_numbers.area_total_users.title':
    'online_event.big_numbers.area_total_users.title',
  'users_manager.big_numbers.area_total_users.description':
    'online_event.big_numbers.area_total_users.description',
  'users_manager.big_numbers.conclusion_avg.title':
    'online_event.big_numbers.conclusion_avg.title',
  'users_manager.big_numbers.conclusion_avg.description':
    'online_event.big_numbers.conclusion_avg.description',
  'users_import.manually.description':
    'online_event.users_import.manually.description',
  'users_import.batch.description':
    'online_event.users_import.batch.description',
  'users_import.batch.number_users_explanation':
    'online_event.users_import.batch.number_users_explanation',
  'users_import.title': 'online_event.users_import.title',
  'class_manager.class_list.title':
    'online_event.group_manager.group_list.title',
  'class_manager.class_list.description':
    'online_event.group_manager.group_list.description',
  'class_manager.class_list.create_class':
    'online_event.group_manager.group_list.add_group'
};
